<template>
  <section>
    <div class="swbg" v-if="backgroundURL" :style="{ backgroundImage: `url('${backgroundURL}')` }"></div>
    <AnimatedBackground v-if="showAnimatedBackground" />
  </section>
</template>

<script>
import AnimatedBackground from './AnimatedBackground';
import { mapGetters } from 'vuex';

export default {
  name: 'Background',
  components: {
    AnimatedBackground
  },
  props: {
  },
  computed: {
    ...mapGetters('poll', ['backgroundURL']),
    showAnimatedBackground () {
      return this.$store.state.showAnimatedBackground
    }
  }
}
</script>

<style scoped lang="scss">
.swbg {
  position: absolute;
  z-index: 0;
  background-image: var(--background-img);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
